import type { StateWorkspaceSummary } from '@/lib/apiTypes'
import { Tooltip } from '@/shared/components/Tooltip'
import { PlanOverviewRow } from '@/features/plans/components/PlanOverviewRow'

// ── Org overview table ─────────────────────────────────────────────────────────
export function PlansOverview({ orgId, workspaces, onSelect }: { orgId: string; workspaces: StateWorkspaceSummary[]; onSelect: (ws: StateWorkspaceSummary) => void }) {
  return (
    <div>
      <div className="eyebrow">
        Plans by workspace
      </div>
      <div className="table-wrap table-scroll fu">
        <table>
          <thead>
            <tr>
              <th>
                <Tooltip text="State workspace these plans belong to. Click a row to open it." placement="top">
                  <span tabIndex={0} className="cursor-help">Workspace</span>
                </Tooltip>
              </th>
              <th>
                <Tooltip text="Action counts from the most recent plan, with when it ran." placement="top">
                  <span tabIndex={0} className="cursor-help">Latest plan</span>
                </Tooltip>
              </th>
              <th>
                <Tooltip text="Resources whose real state no longer matches the last apply." placement="top">
                  <span tabIndex={0} className="cursor-help">Drift</span>
                </Tooltip>
              </th>
              <th>
                <Tooltip text="How far the plan’s prior serial is behind the workspace’s current state." placement="top">
                  <span tabIndex={0} className="cursor-help">Staleness</span>
                </Tooltip>
              </th>
              <th>
                <Tooltip text="Whether org policy currently blocks this workspace." placement="top">
                  <span tabIndex={0} className="cursor-help">Policy</span>
                </Tooltip>
              </th>
              <th>
                <Tooltip text="Distinct outstanding plan refs (PR-scoped plans)." placement="top">
                  <span tabIndex={0} className="cursor-help">Open refs</span>
                </Tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            {workspaces.map((ws) => <PlanOverviewRow key={ws.id} orgId={orgId} ws={ws} onSelect={() => onSelect(ws)} />)}
          </tbody>
        </table>
      </div>
      <div style={{ fontFamily: 'var(--mono)', fontSize: '0.6rem', color: 'var(--text3)', marginTop: 10 }}>
        // Action counts, drift, staleness and policy are read from redacted plan metadata — no plan values leave the worker.
      </div>
    </div>
  )
}

